export const apiBaseUrl = {
  development: 'https://seattlecollisions-backend.test/v1',
  production: 'https://api.seattlecollisions.timganter.io/v1'
}

export const black = {
  default: '#000000',
  light: {},
  dark: {
    a: '#222222',
    b: '#444444',
    c: '#666666',
    gradient: {}
  }
}

export const blue = {
  default: '#2457AB',
  light: {
    a: '#6589C4',
    b: '#BDCCE5',
    c: '#DEE6F3'
  },
  dark: {
    a: '#23457D',
    b: '#242E40',
    c: '#23262B',
    gradient: {}
  }
}

export const brown = {
  default: '#645236',
  light: {
    a: '#95805D',
    b: '#BAA788',
    c: '#D9CDBB'
  },
  dark: {
    a: '#3C311D',
    b: '#2D261A',
    c: '#241E14',
    gradient: {}
  }
}

export const green = {
  default: '#5B8939',
  light: {
    a: '#8CAC74',
    b: '#CDDBC3',
    c: '#E7EEE2'
  },
  dark: {
    a: '#4A682D',
    b: '#343D1E',
    c: '#2C2E1A',
    gradient: {}
  }
}

export const orange = {
  default: '#EF780E',
  light: {
    a: '#F3A056',
    b: '#FAD6B6',
    c: '#FDEBDB'
  },
  dark: {
    a: '#B15C0F',
    b: '#613811',
    c: '#422B13',
    gradient: {}
  }
}

export const pink = {
  default: '#E27FB7',
  light: {
    a: '#EAA5CC',
    b: '#F6D8E9',
    c: '#FBECF4'
  },
  dark: {
    a: '#A86185',
    b: '#5D3A44',
    c: '#402C2C',
    gradient: {}
  }
}

export const purple = {
  default: '#7864AC',
  light: {
    a: '#A092C4',
    b: '#D6D0E6',
    c: '#EBE8F3'
  },
  dark: {
    a: '#5E4E7D',
    b: '#3D3241',
    c: '#30282B',
    gradient: {}
  }
}

export const red = {
  default: '#CA4632',
  light: {
    a: '#D97D6F',
    b: '#EFC7C1',
    c: '#F7E4E1'
  },
  dark: {
    a: '#973928',
    b: '#56291C',
    c: '#3C2419',
    gradient: {}
  }
}

export const teal = {
  default: '#398981',
  light: {
    a: '#74ACA6',
    b: '#C3DBD9',
    c: '#E2EEEC'
  },
  dark: {
    a: '#32685F',
    b: '#2A3D34',
    c: '#272E24',
    gradient: {}
  }
}

export const yellow = {
  default: '#D9B940',
  light: {
    a: '#E4CE79',
    b: '#F3EAC5',
    c: '#FAF5E3'
  },
  dark: {
    a: '#A28A32',
    b: '#5A4C20',
    c: '#3F351B',
    gradient: {}
  }
}

export const chartColors = [
  red.light.a,
  yellow.light.a,
  green.light.a,
  blue.light.a,
  orange.light.a,
  purple.light.a,
  brown.light.a,
  teal.light.a,
  pink.light.a,

  blue.light.b,
  teal.light.b,
  red.light.b,
  yellow.light.b,
  purple.light.b,
  green.light.b,
  orange.light.b,
  pink.light.b
]



// WEBPACK FOOTER //
// ./src/vuex/settings.js